/*!
 * @Author: luoob
 * @Date: 2021-11-08 11:14:32
 * @Last Modified by: luoob
 * @Last Modified time: 2021-11-08 11:14:35
 * @Introduction: 处理报料模块路由
 */

const AuditContacts = () => import('@/views/audit/contact/list.vue')
const ContactDetail = () => import('@/views/audit/contact/detail.vue')
const MediaReport = () => import('@/views/media/report.vue')
const MediaReportDetail = () => import('@/views/media/reportDetail.vue')
const ClueSquareReport = () => import('@/views/clue/square.vue')

/* Layout */
import Layout from '@/layout/index.vue'

export default {
    path: '/audit',
    component: Layout,
    redirect: '/audit/contacts',
    meta: {
        title: '处理报料',
        icon: 'icon-audit',
        alwaysShow: true // will always show the root menu
    },
    children: [{
        path: 'contacts',
        component: AuditContacts,
        name: 'AuditContacts',
        meta: {
            title: '记者报料'
        }
    }, {
        path: 'contact/:id',
        component: ContactDetail,
        name: 'ContactDetail',
        meta: {
            title: '记者报料详情',
            hidden: true
        }
    }, {
        path: 'report',
        component: MediaReport,
        name: 'MediaReport',
        meta: {
            title: '媒体报料'
        }
    }, {
        path: 'report/:id',
        component: MediaReportDetail,
        name: 'MediaReportDetail',
        meta: {
            title: '媒体报料详情',
            hidden: true
        }
    }, {
        path: 'clue_square',
        component: ClueSquareReport,
        name: 'ClueSquareReport',
        meta: {
            title: '线索广场报料'
        }
    }]
}
